import { Select, SelectOption } from '../index';
import { useIntl } from 'react-intl';

interface PaymentStatusSelectorProps {
  name?: string;
  label?: string;
  style?: React.CSSProperties;
}

export const PaymentStatusSelector = ({
  name = 'payment_status',
  label,
  style,
}: PaymentStatusSelectorProps) => {
  const intl = useIntl();

  const paymentStatusOptions = [
    { value: 'paid', label: intl.formatMessage({ id: 'transactions.payment_status.paid' }) },
    { value: 'unpaid', label: intl.formatMessage({ id: 'transactions.payment_status.unpaid' }) },
  ];

  return (
    <Select
      name={name}
      label={label || intl.formatMessage({ id: 'transactions.filter.payment_status' })}
      placeholder={intl.formatMessage({ id: 'transactions.filter.payment_status.placeholder' })}
      allowClear
      style={style}
    >
      {paymentStatusOptions.map((option) => (
        <SelectOption key={option.value} value={option.value}>
          {option.label}
        </SelectOption>
      ))}
    </Select>
  );
};
